<template>
    <div>
        <section class="section">
            <nav class="level">
            <div class="level-left">
                <div class="level-item">
                    <b-dropdown>
                        <button class="button is-primary" slot="trigger">
                            <span>Actions</span>
                            <i class="material-icons" style="font-size: 16px;">expand_more</i>
                        </button>
                        <b-dropdown-item @click="edit(0)">Create New</b-dropdown-item>
                        <b-dropdown-item @click="deleteRows('/articles/delete.php', 'findArticles')">Delete</b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <b-field>
                        <b-input custom-class="binput" :placeholder="'Search...'"
                            type="search" icon="magnify" @keyup.enter.native="search" v-model.trim="filterText">
                        </b-input>
                    </b-field>
                </div>
            </div>
        </nav>    
        <b-table
            striped
            :data="getDataList"
            :checked-rows.sync="dataGrid.checkedRows"
            :default-sort-direction="dataGrid.defaultSortDirection"
            focusable
            :paginated="dataGrid.isPaginated"
            :per-page="dataGrid.perPage"
            :current-page.sync="dataGrid.currentPage"
            :pagination-simple="dataGrid.isPaginationSimple"
            checkable
            default-sort="created_at" style=" font-size: 0.8em;">

            <template slot-scope="props">

                <b-table-column field="created_at" :label="'Date'" sortable>
                    {{ changeDate(props.row.created_at) }}
                </b-table-column>

                <b-table-column field="article_title" :label="'Name'" sortable>
                    {{ props.row.article_title.length>35 ? props.row.article_title.substr(0, 30)+'.....' : props.row.article_title }}
                </b-table-column>

                <b-table-column field="wrrite_by_name" :label="'Written By'" sortable>
                    {{ props.row.wrrite_by_name }}
                </b-table-column>

                <b-table-column>
                    <a @click="edit(props.row)" :title="'edit'">
                        <i class="material-icons" style="font-size: 16px;">edit</i>
                    </a>
                </b-table-column>
                <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Create New Record</p>
                    </div>
                </section>
            </template>
            </template>
        </b-table>
        
        </section> 
        
        <b-modal :active.sync="showForm">
            <Form 
                @closeModule="showForm = !showForm"></Form>
        </b-modal>

    </div>
</template>

<script>
import Form from './Form'

export default {
    data() {
        return {
            filterText: '',
            filterText1: '',
            showForm: false
        }
    },
    computed: {
        getDataList() {

            let list = this.$store.state.articles.list
            if(this.filterText1.length>0) {
                let filterText = this.filterText1

                return list.filter(function (element) {
                    return element.article_title.toLowerCase().match(filterText.toLowerCase()) ||
                        element.wrrite_by_name.toLowerCase().match(filterText.toLowerCase())
                });
            }
            return list
        }
    },
    methods: {
        edit(prop) {
            if(prop === 0) {
                this.$store.commit('resetArticleProfile')
                this.showForm = true
            } else {
                this.$store.commit('setArticleProfileInfo', prop)
                this.showForm = true
            }
        },
        search() {
            this.filterText1 = this.filterText
        }
    },
    created() {
        this.$store.dispatch('findArticles')
    },
    components: {
        Form
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Index.vue